import React, { createContext, useContext, useCallback, useRef } from 'react';

const ScrollSyncContext = createContext(null);

export const ScrollSyncProvider = ({ children }) => {
  const broadcastRefs = useRef([]);

  const registerBroadcast = useCallback((fn) => {
    broadcastRefs.current.push(fn);
    // Return cleanup function to deregister handler on unmount
    return () => {
      broadcastRefs.current = broadcastRefs.current.filter(f => f !== fn);
    };
  }, []);

  const broadcast = useCallback((viewportIdx, fraction) => {
    broadcastRefs.current.forEach(fn => fn(viewportIdx, fraction));
  }, []);

  return (
    <ScrollSyncContext.Provider value={{ registerBroadcast, broadcast }}>
      {children}
    </ScrollSyncContext.Provider>
  );
};

export const useScrollSync = () => {
  const context = useContext(ScrollSyncContext);
  if (!context) {
    throw new Error('useScrollSync must be used within a ScrollSyncProvider');
  }
  return context;
};
